module.exports = __webpack_public_path__ + "img/icon_work_05.38bd7731.png";